const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

const animateHorizontalImage = () => {
  const image = document.querySelector(".more-work-img");
  const swiper = document.querySelector("#swiper-work-detail");
  const swipperTriggerAnim = document.querySelector(".carousel-section");

  if (!image) return;

  gsap.set(image, {
    x: -200,
    opacity: 0,
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: image,
      start: "-60% 60%",
      end: "bottom 60%",
      toggleActions: "play none none reverse",
    },
    defaults: {
      duration: 1.3,
    },
  });

  tl.to(image, {
    x: 0,
    opacity: 1,
  });

  if (!swiper || !isDesktop) return;

  gsap.set(swiper, {
    x: 200,
    opacity: 0,
  });

  gsap
    .timeline({
      scrollTrigger: {
        trigger: swipperTriggerAnim,
        start: "top 80%",
        end: "bottom 80%",
        toggleActions: "play none none reverse",
      },
    })
    .to(swiper, {
      opacity: 1,
      x: 0,
      duration: 1,
    });
};

export default animateHorizontalImage;
